import React, { lazy } from 'react';
import { ArrowRightIcon, HomeIcon, HandshakeIcon, FilterIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="relative overflow-hidden bg-white pt-4 pb-8 sm:pt-16 sm:pb-24" data-id="element-158">
      {/* Fondo animado radial */}
      <div className="absolute inset-0 z-0" data-id="element-159">
        <div className="absolute left-1/2 top-0 -translate-x-1/2 blur-3xl opacity-30" data-id="element-160">
          <svg viewBox="0 0 1208 1024" className="w-[75rem] h-[64rem]" aria-hidden="true" data-id="element-161">
            <defs data-id="element-162">
              <radialGradient id="radial" cx="50%" cy="0%" r="100%" gradientUnits="userSpaceOnUse" data-id="element-163">
                <stop stopColor="#3b82f6" offset="0%" data-id="element-164" />
                <stop stopColor="#1d4ed8" offset="50%" data-id="element-165" />
                <stop stopColor="#1e3a8a" offset="100%" data-id="element-166" />
              </radialGradient>
            </defs>
            <rect width="1208" height="1024" fill="url(#radial)" data-id="element-167" />
          </svg>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-168">
        <div className="flex flex-col lg:flex-row items-center" data-id="element-169">
          {/* Texto */}
          <div className="text-center lg:text-left lg:w-1/2 lg:pr-8 z-10 relative" data-id="element-170">
            <div className="max-w-[38rem] mx-auto lg:mx-0" data-id="element-171">
              <h1 className="text-4xl sm:text-4xl md:text-5xl font-bold text-gray-900 tracking-tight" data-id="element-172">
                Vende tu propiedad{' '}
                <span className="inline-block" data-id="element-173">
                  con{' '}
                  <span className="bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent" data-id="element-174">
                    tarifa fija
                  </span>
                </span>
              </h1>
            </div>

            <p className="mt-3 sm:mt-6 text-sm sm:text-lg text-gray-600 max-w-3xl mx-auto lg:mx-0" data-id="element-175">
              Un equipo experto que lidera tu venta con un solo corredor
              principal, abiertos a canje, menos visitas (mejores filtros) y sin
              comisión al comprador.
            </p>

            <div className="mt-4 sm:mt-10 flex flex-col sm:flex-row gap-2 justify-center lg:justify-start" data-id="element-176">
              <a href="#pricing" className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center text-sm" data-id="element-177">
                Quiero vender
                <ArrowRightIcon className="ml-2 h-3 w-3 sm:h-4 sm:w-4" data-id="element-178" />
              </a>
              <a href="#features" className="px-4 py-2 bg-white text-gray-700 font-medium rounded-md border border-gray-200 hover:bg-gray-50 transition-colors text-sm" data-id="element-179">
                Cómo funciona
              </a>
            </div>

            <div className="mt-5 sm:mt-12 flex flex-wrap justify-center lg:justify-start gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-600" data-id="element-180">
              <div className="flex items-center" data-id="element-181">
                <HomeIcon className="h-3 w-3 sm:h-4 sm:w-4 text-blue-600 mr-1" data-id="element-182" />
                <span data-id="element-183">Fotos pro · Tour virtual · Plano</span>
              </div>
              <div className="flex items-center" data-id="element-184">
                <HandshakeIcon className="h-3 w-3 sm:h-4 sm:w-4 text-blue-600 mr-1" data-id="element-185" />
                <span data-id="element-186">Abiertos a canje (red de corredores)</span>
              </div>
              <div className="flex items-center" data-id="element-187">
                <FilterIcon className="h-3 w-3 sm:h-4 sm:w-4 text-blue-600 mr-1" data-id="element-188" />
                <span data-id="element-189">Menos visitas, mejores filtros</span>
              </div>
            </div>
          </div>

          {/* Imagen de apoyo */}
          <div className="mt-6 lg:mt-0 lg:w-1/2 z-0" data-id="element-190">
            <div className="relative mx-auto w-full max-w-xs lg:max-w-none" data-id="element-191">
              <div className="relative rounded-xl shadow-lg overflow-hidden border border-gray-200" data-id="element-192">
                <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=1200&auto=format&fit=crop" alt="Departamento moderno listo para vender" className="w-full" loading="lazy" decoding="async" data-id="element-193" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};